//vo
import gameIntroSrc from "assets/audio/vo/Game_Intro.mp3";
import roundIntro1Src from "assets/audio/vo/Round_Intro_1.mp3";
import roundIntro2Src from "assets/audio/vo/Round_Intro_2.mp3";
import roundIntro3Src from "assets/audio/vo/Round_Intro_3.mp3";
import roundIntro4Src from "assets/audio/vo/Round_Intro_4.mp3";
import roundIntro5Src from "assets/audio/vo/Round_Intro_5.mp3";
import roundIntro6Src from "assets/audio/vo/Round_Intro_6.mp3";
import roundIntro7Src from "assets/audio/vo/Round_Intro_7.mp3";
import answersLockedInSrc from "assets/audio/vo/Answers_LockedIn.mp3";
import answersTimesUpSrc from "assets/audio/vo/Answers_TimesUp.mp3";
import chooseCategorySrc from "assets/audio/vo/ChooseCategory.mp3"
import gameOverOneMillionSrc from "assets/audio/vo/Game_Over_One_Million.mp3";
import gameOverNoCashSrc from "assets/audio/vo/Game_Over_No_Cash.mp3";
import gameOverWithCashSrc from "assets/audio/vo/Game_Over_With_Cash.mp3";
import answeringTimesRunningOutSrc from "assets/audio/vo/Times_Running_Out.mp3";
import categoryTimesRunningOutSrc from "assets/audio/vo/Category_Times_Running_Out.mp3"
import bringOnTheDropSrc from "assets/audio/vo/Bring_On_The_Drop.mp3";
import bringOnTheAnsersSrc from "assets/audio/vo/Bring_On_The_Answers.mp3";
import timerStartedSrc from "assets/audio/vo/Timer_Started.mp3";
import categoryTimesUpSrc from "assets/audio/vo/Category_TimesUp.mp3"
import answeringHintSrc from "assets/audio/vo/Answering_Hint.mp3";
import dontKnowHowToPlaySrc from "assets/audio/vo/Dont_know_how_to_play.mp3";
import positiveDrop1Src from "assets/audio/vo/Positive_Drop_1.mp3";
import positiveDrop2Src from "assets/audio/vo/Positive_Drop_2.mp3";
import positiveDrop3Src from "assets/audio/vo/Positive_Drop_3.mp3";
import positiveDrop4Src from "assets/audio/vo/Positive_Drop_4.mp3";
import positiveDrop5Src from "assets/audio/vo/Positive_Drop_5.mp3";
import positiveDrop6Src from "assets/audio/vo/Positive_Drop_6.mp3";
import positiveDrop7Src from "assets/audio/vo/Positive_Drop_7.mp3";
import negativeDrop1Src from "assets/audio/vo/Negative_Drop_1.mp3";
import negativeDrop2Src from "assets/audio/vo/Negative_Drop_2.mp3";
import negativeDrop3Src from "assets/audio/vo/Negative_Drop_3.mp3";
import negativeDrop4Src from "assets/audio/vo/Negative_Drop_4.mp3";
import negativeDrop5Src from "assets/audio/vo/Negative_Drop_5.mp3";
import negativeDrop6Src from "assets/audio/vo/Negative_Drop_6.mp3";
import negativeDrop7Src from "assets/audio/vo/Negative_Drop_7.mp3";

//sfx
import showCategorisSrc from "assets/audio/sfx/CategoriesFlyIn.mp3";
import categorySelectedSrc from "assets/audio/sfx/CategorySelected.mp3";
import moneyDroppedSrc from "assets/audio/sfx/MoneyDropped.mp3";
import tickSrc from "assets/audio/sfx/TimerTick.mp3";
import tockSrc from "assets/audio/sfx/TimerTock.mp3";
import timesUpSrc from "assets/audio/sfx/TimesUp.mp3";
import anserRevealSrc from "assets/audio/sfx/AnswerReveal.mp3";
import playerLockedInSrc from "assets/audio/sfx/Locked_In.mp3"

//music
import gameIntroStingSrc from "assets/audio/music/MDMD_LetsPlaySting_ReducedFalloff.mp3"
import answerLoopSrc from "assets/audio/music/MDMD_AskingQuestion_8barLoop.mp3"
import revealDropsLoopSrc from "assets/audio/music/MDMD_Reveal_8barLoop.mp3"
import introLoopSrc from "assets/audio/music/MDMD_Intro_4barLoop.mp3"
import categorySelectLoopSrc from "assets/audio/music/MDMD_CategorySelect_WithClock_8barLoop.mp3"
import gameOverLoopSrc from "assets/audio/music/MDMD_Game_Over_8barLoop.mp3"

// shape:
//{
//    src: srcFile|[srcFile, fallbackFile],
//    volume: 0.4,
//    loop: false|true
//},

export const SFX = {
    SHOW_CATEGORIES: {
        src: showCategorisSrc,
        volume: 0.4,
        preload: true,
    },
    CATEGORY_SELECTED: {
        src: categorySelectedSrc,
        volume: 0.6,
        preload: true,
    },
    ANSWER_REVEAL: {
        src: anserRevealSrc,
        volume: 0.3,
        preload: true,
    },
    MONEY_DROPPED: {
        src: moneyDroppedSrc,
        volume: 0.5,
        preload: true,
    },
    TIMER_TICK: {
        src: tickSrc,
        preload: true,
        volume: 0.6,
    },
    TIMER_TOCK: {
        src: tockSrc,
        volume: 0.6,
        preload: true,
    },
    TIMES_UP: {
        src: timesUpSrc,
        volume: 0.6,
        preload: true,
    },
    PLAYER_LOCKED_IN: {
        src: playerLockedInSrc,
        volume: 0.4,
        preload: true,
    }
}

export const MUSIC = {

    GAME_INTO_STING: {
        src: gameIntroStingSrc,
        volume: 0.6,
        loop: false,
    },
    GAME_INTO_LOOP: {
        src: introLoopSrc,
        volume: 0.2,
        loop: true,
    },
    CATEGORY_SELECT_LOOP: {
        src: categorySelectLoopSrc,
        volume: 0.4,
        loop: true,
    },
    ASKING_QUESTION_LOOP: {
        src: answerLoopSrc,
        volume: 0.4,
        loop: true,
    },
    REVEAL_LOOP: {
        src: revealDropsLoopSrc,
        volume: 0.4,
        loop: true,
    },
    GAME_OVER_LOOP: {
        src: gameOverLoopSrc,
        volume: 0.4,
        loop: true,
    }
}

export const VO = {
    GAME_INTO: {
        src: gameIntroSrc,
        volume: 1.0,
    },
    ROUND_INTRO: {
        1: {
            src: roundIntro1Src,
            volume: 1.0,
        },
        2: {
            src: roundIntro2Src,
            volume: 1.0,
        },
        3: {
            src: roundIntro3Src,
            volume: 1.0,
        },
        4: {
            src: roundIntro4Src,
            volume: 1.0,
        },
        5: {
            src: roundIntro5Src,
            volume: 1.0,
        },
        6: {
            src: roundIntro6Src,
            volume: 1.0,
        },
        7: {
            src: roundIntro7Src,
            volume: 1.0,
        },
    },

    TIMER_START_ANSWERING: {
        src: timerStartedSrc,
        volume: 1.0,
    },

    ANSWERING_TIMES_RUNNING_OUT: {
        src: answeringTimesRunningOutSrc,
        volume: 1.0,
    },

    CATEGORY_TIMES_RUNNING_OUT: {
        src: categoryTimesRunningOutSrc,
        volume: 1.0,
    },

    ANSWERS_LOCKED_IN: {
        src: answersLockedInSrc,
        volume: 1.0,
    },

    ANSWERS_TIMES_UP: {
        src: answersTimesUpSrc,
        volume: 1.0,
    },

    CATEGORY_TIMES_UP: {
        src: categoryTimesUpSrc,
        volume: 1.0,
    },

    CHOOSE_CATEGORY: {
        src: chooseCategorySrc,
        volume: 1.0,
    },

    BRING_ON_ANSWERS: {
        src: bringOnTheAnsersSrc,
        volume: 1.0,
    },

    BRING_ON_THE_DROP: {
        src: bringOnTheDropSrc,
        volume: 1.0,
    },

    GAME_OVER_WITH_WINNERS: {
        src: gameOverWithCashSrc,
        volume: 1.0,
    },

    GAME_OVER_ALL_OUT: {
        src: gameOverNoCashSrc,
        volume: 1.0,
    },

    GAME_OVER_ONE_MILLION: {
        src: gameOverOneMillionSrc,
        volume: 1.0,
    },

    ANSWERING_HINT: {
        src: answeringHintSrc,
        volume: 1.0,
    },

    DONT_KNOW_HOW_TO_PLAY: {
        src: dontKnowHowToPlaySrc,
        volume: 1.0,
    },

    POSITIVE_DROP: [
        {
            src: positiveDrop1Src,
            volume: 1.0,
        },
        {
            src: positiveDrop2Src,
            volume: 1.0,
        },
        {
            src: positiveDrop3Src,
            volume: 1.0,
        },
        {
            src: positiveDrop4Src,
            volume: 1.0,
        },
        {
            src: positiveDrop5Src,
            volume: 1.0,
        },
        {
            src: positiveDrop6Src,
            volume: 1.0,
        },
        {
            src: positiveDrop7Src,
            volume: 1.0,
        },
    ],

    NEGATIVE_DROP: [
        {
            src: negativeDrop1Src,
            volume: 1.0,
        },
        {
            src: negativeDrop2Src,
            volume: 1.0,
        },
        {
            src: negativeDrop3Src,
            volume: 1.0,
        },
        {
            src: negativeDrop4Src,
            volume: 1.0,
        },
        {
            src: negativeDrop5Src,
            volume: 1.0,
        },
        {
            src: negativeDrop6Src,
            volume: 1.0,
        },
        {
            src: negativeDrop7Src,
            volume: 1.0,
        },
    ]
}

// Helper function to extract audio sources that should be preloaded
export const getPreloadAudio = () => {
    const sources = [];

    const extractFromObject = (obj) => {
        if (!obj) return;

        // If this is an audio definition with src and preload flag
        if (obj.src && obj.preload === true) {
            // Handle both single src and array of src
            if (Array.isArray(obj.src)) {
                sources.push(...obj.src.filter(s => s)); // Filter out empty strings
            } else if (obj.src) {
                sources.push(obj.src);
            }
        }

        // Recursively check nested objects (for ROUND_INTRO case)
        if (typeof obj === 'object' && !obj.src) {
            Object.values(obj).forEach(value => {
                if (typeof value === 'object') {
                    extractFromObject(value);
                }
            });
        }
    };

    // Process all audio types
    [SFX, VO, MUSIC].forEach(audioObj => extractFromObject(audioObj));

    return sources;
};